import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { PartsOrder } from '@contracts/interfaces/parts-order.interface';
import { ConnectionService } from './connection.service';

@Injectable({
  providedIn: 'root'
})
export class PartsOrderService {

  constructor(
    private http: HttpClient,
    private connectionService: ConnectionService
  ) {}

  private hydrate(order: PartsOrder): PartsOrder {
    if (!order) {
      return order;
    }

    return {
      ...order,
      expectedDate: order.expectedDate ? new Date(order.expectedDate) : undefined,
      receivedDate: order.receivedDate ? new Date(order.receivedDate) : undefined,
      createdAt: order.createdAt ? new Date(order.createdAt) : undefined,
      updatedAt: order.updatedAt ? new Date(order.updatedAt) : undefined
    };
  }

  list(): Observable<PartsOrder[]> {
    return this.http.post<PartsOrder[]>(`${this.connectionService.address}/parts-order-service/list`, {})
      .pipe(map(orders => (orders || []).map(order => this.hydrate(order))));
  }

  create(order: PartsOrder): Observable<PartsOrder> {
    return this.http.post<PartsOrder>(`${this.connectionService.address}/parts-order-service/create`, { order })
      .pipe(map(o => this.hydrate(o)));
  }

  update(order: PartsOrder): Observable<PartsOrder> {
    return this.http.post<PartsOrder>(`${this.connectionService.address}/parts-order-service/update`, { order })
      .pipe(map(o => this.hydrate(o)));
  }
}
